import React from "react";
import Typography from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import info from "../../../assets/images/davos.jpg";

const Details = () => {
  return (
    <>
      <Grid container margin={{ xs: "8% 0%", sm: "0%" }}>
        <Grid xs={12} sm={6} paddingRight={"3%"}>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            Oluseun Onigbinde, Africa’s social and data entrepreneur has been
            honourably invited and he’s scheduled to attend the World Economic
            Forum, Davos, Switzerland. The World Economic Forum Annual Meeting,
            themed <i>“Collaboration for the Intelligent Age,”</i> scheduled to
            take place in Davos, Switzerland, from January 20–24, 2025.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            The Annual Meeting brings together global leaders, policymakers,
            innovators, and industry experts to engage in critical discussions
            on shaping the future of technology, economy, and sustainability.
            This year’s theme focuses on fostering collaboration and harnessing
            emerging technologies to address global challenges and
            opportunities.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            The BudgIT co-founder and CEO of Kwerty Investments will actively
            participate in sessions and events at the meeting while leveraging
            the opportunity to engage with investors and stakeholders on the
            sidelines. These discussions will focus on exploring new avenues for
            collaboration, attracting strategic investments in data and
            artificial intelligence, and advancing Kwerty’s mission to drive
            sustainable growth and innovation across its core sectors.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            Speaking on the significance of attending the Annual Meeting,
            Oluseun Onigbinde said:{" "}
            <i>
              {" "}
              "The World Economic Forum is a platform where ideas meet action.
              It provides an unparalleled opportunity to engage with global
              leaders, foster partnerships, and chart a course for impactful
              solutions in today’s intelligent age. I look forward to sharing
              Kwerty’s vision, learning from thought leaders, and creating
              pathways for transformative investments."
            </i>
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            Kwerty Investments remains committed to advancing innovation,
            sustainability, and economic inclusivity through strategic
            investments and collaborations. The company believes this engagement
            at the World Economic Forum will catalyze new initiatives that align
            with its vision of empowering industries and communities globally.
          </Typography>
        </Grid>
        <Grid
          xs={12}
          sm={6}
          display={{ xs: "none", sm: "block" }}
          marginTop={{ xs: "0%", sm: "4%" }}
        >
          <Box
            component="img"
            height={{ xs: "95vh", sm: "650px" }}
            sx={{
              objectFit: "cover",
              width: "100%",
            }}
            src={info}
            alt={"image"}
          />
        </Grid>
        <Grid xs={12} sm={12}>
          <Typography
            variant={"h6"}
            color={"#071783"}
            paddingTop={{ xs: "4%", sm: "0%" }}
            paddingBottom={"1%"}
            fontWeight={700}
          >
            About Kwerty Investments
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"2%"}
            lineHeight={1.5}
            fontStyle={"italic"}
          >
            Kwerty Investments, founded in 2021 and headquartered in Washington,
            D.C., is a dynamic investment firm dedicated to fostering
            innovation, promoting sustainable growth, and creating value across
            diverse industries, including technology, agriculture, and renewable
            energy. Committed to delivering measurable impact, Kwerty
            Investments partners with businesses and stakeholders to unlock
            opportunities and shape a more sustainable and prosperous future.
          </Typography>
          <Typography
            variant={"h6"}
            color={"#071783"}
            paddingBottom={"1%"}
            paddingTop={{ xs: "4%", sm: "0%" }}
            fontWeight={700}
          >
            Signed
          </Typography>
          <Typography variant={"h6"} color={"#000"} paddingBottom={"1%"}>
            Oluwaseun Afolabi
          </Typography>
          <Typography variant={"h6"} color={"#000"} paddingBottom={"1%"}>
            COO
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default Details;
